import { useIntl } from 'react-intl'
import { type Locale } from 'invictus-sdk-typescript'

import { type Pathname } from '@Types/navigation/navigation'
import { getAbsoluteUrl } from '@Utils/router'

type UseFullRefreshReloadReturn = {
  goToWithFullReload: (path: Pathname, newLocale?: Locale, skipBasePath?: boolean) => void
}

export const useFullRefreshReload = (): UseFullRefreshReloadReturn => {
  const { locale } = useIntl()

  const goToWithFullReload = (path: Pathname, newLocale?: Locale, skipBasePath = false) => {
    window.location.href = getAbsoluteUrl(path, newLocale ?? (locale as Locale), skipBasePath)
  }

  return { goToWithFullReload }
}
